import { GoogleGenerativeAI } from "@google/generative-ai";
import toast from "react-hot-toast";
import { actualizarVerificacion, registrarNadador } from "./configuracionFirebase";
export const genAI = new GoogleGenerativeAI(process.env.REACT_APP_GOOGLE_KEY_AI);

export const modelPDF = genAI.getGenerativeModel({ model: "gemini-2.5-flash" });

export const extraerDatosPdf = (selectedFile, insc, idTorneo) => {
  if (selectedFile) {
    const loadingToast = toast.loading('Extrayendo información...');
    try {
      const wordMimeTypes = [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
        "application/msword", // DOC (antiguo)
        "application/vnd.openxmlformats-officedocument.wordprocessingml.template", // DOTX
        "application/vnd.ms-word.document.macroEnabled.12", // DOCM (habilitado para macros)
        "application/vnd.ms-word.template.macroEnabled.12" // DOTM (plantilla habilitada para macros)
      ];
      if(wordMimeTypes.includes(selectedFile.type)){
        toast.error('¡UPS! Ocurrio un error, tipo de archivo incorrecto. Solo se admite PDF o Image', {
          id: loadingToast,
        });
        return null;
      }
      const reader = new FileReader();
  
      reader.onloadend = async () => {
        const base64PDF = reader.result.split(",")[1];
        
        const result = await modelPDF.generateContent([
          {
            inlineData: {
              data: base64PDF,
              mimeType: selectedFile.type,
            },
          },
          `Extraes el numero de identificacion sin puntos, nombres, apellidos, género (completo ejemplo: Masculino, Femenino), tipo de documento, si trae firma o no, si es una foto o una foto en pdf o un escrito a mano ya sea en pdf o word, fecha de nacimiento (formato yyyy-mm-dd) del contenido y pasamelo en formato json, sin dar mas texto solo el json, los atributos deben estar asi numeroIdentificacion, nombres, apellidos, genero, fechaNacimiento. Añade un atributo valida si el tipo de documento es tarjeta de identidad o cedula de ciudadania, si la firma es true, si el tipo de archivo es diferente a null y si todos los atributos tienen sus valores, es true, de los contrario es false`,
        ]);
        const resp = result.response.text();
        const jsonRespuesta = resp.replace('```json', '').replace('```', '');
        if(JSON.parse(jsonRespuesta)){
          const objDeportista = JSON.parse(jsonRespuesta);
          if(objDeportista.valida){
            if(objDeportista.numeroIdentificacion === insc.identificacion){
              if(objDeportista.fechaNacimiento === insc.fechaNacimiento){
                actualizarVerificacion(insc.identificacion, insc, objDeportista).then(()=>{
                  insc.fechaNacimiento = objDeportista.fechaNacimiento;
                  insc.identificacion = objDeportista.numeroIdentificacion;
                  insc.verificado = 'Verificado';
                  registrarNadador(idTorneo, insc);
                  toast.success('Deportista ' + insc.nombre + ', verificado correctamente.', {
                    id: loadingToast,
                  });
                }).catch(() =>{
                  toast.error('Estás intentando verificar al mismo deportista más de una vez. Esta es una actividad inusual y sospechosa. Recuerda que el equipo de PROWEBSPORTS está monitoreando constantemente este tipo de acciones.', {
                    id: loadingToast,
                  });
                });
              }else{
                toast.error('¡UPS! La fecha de nacimiento que esta en el documento no coincide con la fecha de nacimiento del deportista inscrito.', {
                  id: loadingToast,
                });
              }
            }else{
              toast.error('¡UPS! El numero del documento no coincide con el deportista inscrito.', {
                id: loadingToast,
              });
            }
          }else{
            toast.error('¡UPS! El documento no es valido', {
              id: loadingToast,
            });
          }
        }
      };
      reader.readAsDataURL(selectedFile);
    } catch (err) {
      toast.error('¡UPS! Ocurrio un error, el archivo no es valido o el documento no es valido', {
        id: loadingToast,
      });
    }
  }
};